import APPAREL_DATA from "./apparel/apparel"
import MERCHANDISE_DATA from "./apparel/merchandise"

const FULL_APPAREL_DATA = {
  ...APPAREL_DATA,
  ...MERCHANDISE_DATA,
}

export default FULL_APPAREL_DATA
